import { render, staticRenderFns } from "./send_message.vue?vue&type=template&id=0af1f35e&scoped=true"
import script from "./send_message.vue?vue&type=script&lang=js"
export * from "./send_message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1f35e",
  null
  
)

export default component.exports